const WidgesOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1158_1242)">
      <rect
        x="1.6665"
        y="11.6665"
        width="6.66667"
        height="6.66667"
        rx="2"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <rect
        x="1.6665"
        y="1.6665"
        width="6.66667"
        height="6.66667"
        rx="2"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <rect
        x="11.6665"
        y="11.6665"
        width="6.66667"
        height="6.66667"
        rx="2"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M11.153 6.96158C10.3719 6.18053 10.3719 4.91421 11.153 4.13316L13.0386 2.24754C13.8197 1.46649 15.086 1.46649 15.867 2.24754L17.7527 4.13316C18.5337 4.91421 18.5337 6.18054 17.7527 6.96158L15.867 8.8472C15.086 9.62825 13.8197 9.62825 13.0386 8.8472L11.153 6.96158Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_1158_1242">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ShippingDeliveryOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1158_1249)">
      <path
        d="M18.3332 14.3332V7.23629C18.3332 6.32801 18.024 5.44677 17.4566 4.73751L16.2008 3.16772C15.4417 2.21886 14.2925 1.6665 13.0773 1.6665H6.92234C5.7072 1.6665 4.55795 2.21886 3.79886 3.16772L2.54303 4.73751C1.97563 5.44677 1.6665 6.32801 1.6665 7.23629V14.3332C1.6665 16.5423 3.45737 18.3332 5.6665 18.3332H14.3332C16.5423 18.3332 18.3332 16.5423 18.3332 14.3332Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 5.8335H17.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.1665 11.3215L8.08909 10.2441C7.76366 9.91864 7.23602 9.91864 6.91058 10.2441L5.83317 11.3215M7.49984 14.1667V10.4882"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M14.1665 12.845L13.0891 13.9224C12.7637 14.2479 12.236 14.2479 11.9106 13.9224L10.8332 12.845M12.4998 9.99984V13.6783"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1158_1249">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ShippingDeliveryOutlineReturn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 12V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V12"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M12 8H19.5C19.8148 8 20.1111 8.14819 20.3 8.4L21.8 10.4C22.2944 11.0592 21.824 12 21 12H15.5C15.1852 12 14.8889 11.8518 14.7 11.6L12 8Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M12 8H4.5C4.18524 8 3.88885 8.14819 3.7 8.4L2.2 10.4C1.70557 11.0592 2.17595 12 3 12H8.5C8.81476 12 9.11115 11.8518 9.3 11.6L12 8Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M9.58586 4L8 2L14.5001 2C15.3285 2 16.0001 2.67157 16.0001 3.5V3.5C16.0001 4.32843 15.3285 5 14.5001 5L13.0001 5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const DeviceOutlineComputer = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
  >
    <rect
      x="2.5"
      y={2}
      width={20}
      height={16}
      rx={3}
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9.5 22H12.5M15.5 22H12.5M12.5 22V18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 15H13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const TruckOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M14.5 19V7M14.5 19H16.5M14.5 19H9.5M14.5 7C14.5 4.79086 12.7091 3 10.5 3H6.5C4.29086 3 2.5 4.79086 2.5 7V15C2.5 16.8652 3.77667 18.4323 5.50384 18.875M14.5 7H17.7091C18.2172 7 18.7063 7.1934 19.077 7.54093L21.8679 10.1574C22.2712 10.5355 22.5 11.0636 22.5 11.6165V17C22.5 18.1046 21.6046 19 20.5 19M20.5 19C20.5 20.1046 19.6046 21 18.5 21C17.3954 21 16.5 20.1046 16.5 19M20.5 19C20.5 17.8954 19.6046 17 18.5 17C17.3954 17 16.5 17.8954 16.5 19M9.5 19C9.5 20.1046 8.60457 21 7.5 21C6.39543 21 5.5 20.1046 5.5 19C5.5 18.958 5.50129 18.9163 5.50384 18.875M9.5 19C9.5 17.8954 8.60457 17 7.5 17C6.43742 17 5.56838 17.8286 5.50384 18.875"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
);

const MobileOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="5"
      y="2"
      width="14"
      height="20"
      rx="3"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M11 19H13"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
const ChartArrowOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1158_1256)">
      <path
        d="M15.8332 1.6665H17.4998C17.9601 1.6665 18.3332 2.0396 18.3332 2.49984V4.1665M17.4998 2.49984C10.8819 7.82597 7.4516 9.26062 1.6665 9.99984M14.9998 8.33317V16.6665C14.9998 17.587 15.746 18.3332 16.6665 18.3332C17.587 18.3332 18.3332 17.587 18.3332 16.6665V8.33317C18.3332 7.4127 17.587 6.6665 16.6665 6.6665C15.746 6.6665 14.9998 7.4127 14.9998 8.33317ZM1.6665 14.9998L1.6665 16.6665C1.6665 17.587 2.4127 18.3332 3.33317 18.3332C4.25364 18.3332 4.99984 17.587 4.99984 16.6665L4.99984 14.9998C4.99984 14.0794 4.25365 13.3332 3.33317 13.3332C2.4127 13.3332 1.6665 14.0794 1.6665 14.9998ZM8.33317 11.6665V16.6665C8.33317 17.587 9.07936 18.3332 9.99984 18.3332C10.9203 18.3332 11.6665 17.587 11.6665 16.6665V11.6665C11.6665 10.746 10.9203 9.99984 9.99984 9.99984C9.07936 9.99984 8.33317 10.746 8.33317 11.6665Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1158_1256">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ChatNotificationOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.6665 11.6667H13.3332M6.6665 8.33333H9.99984M18.3052 9.34718C18.3237 9.56231 18.3332 9.78005 18.3332 10C18.3332 14.1421 14.9753 17.5 10.8332 17.5H4.99984C3.15889 17.5 1.6665 16.0076 1.6665 14.1667V10C1.6665 5.85786 5.02437 2.5 9.1665 2.5H10.8332C11.0531 2.5 11.2709 2.50947 11.486 2.52802M18.3332 5C18.3332 6.38071 17.2139 7.5 15.8332 7.5C14.4525 7.5 13.3332 6.38071 13.3332 5C13.3332 3.61929 14.4525 2.5 15.8332 2.5C17.2139 2.5 18.3332 3.61929 18.3332 5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

const IdCardOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.9998 14.1667H12.4998M14.9998 11.6667H12.4998M4.99984 17.5H14.9998C16.8408 17.5 18.3332 16.0076 18.3332 14.1667V5.83333C18.3332 3.99238 16.8408 2.5 14.9998 2.5H4.99984C3.15889 2.5 1.6665 3.99238 1.6665 5.83333V14.1667C1.6665 16.0076 3.15889 17.5 4.99984 17.5ZM6.6665 5.83333H8.33317C9.25364 5.83333 9.99984 6.57953 9.99984 7.5C9.99984 8.42047 9.25364 9.16667 8.33317 9.16667H6.6665C5.74603 9.16667 4.99984 8.42047 4.99984 7.5C4.99984 6.57953 5.74603 5.83333 6.6665 5.83333Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const IdeaOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.6665 14.9998H13.3332M6.6665 14.9998C6.6665 16.8408 8.15889 18.3332 9.99984 18.3332C11.8408 18.3332 13.3332 16.8408 13.3332 14.9998M6.6665 14.9998V13.1571C6.6665 12.6123 6.38866 12.1134 5.99278 11.7391C4.86818 10.6757 4.1665 9.16973 4.1665 7.49984C4.1665 4.27818 6.77818 1.6665 9.99984 1.6665C13.2215 1.6665 15.8332 4.27818 15.8332 7.49984C15.8332 9.16973 15.1315 10.6757 14.0069 11.7391C13.611 12.1134 13.3332 12.6123 13.3332 13.1571V14.9998M8.33317 7.49984L9.99984 9.1665M9.99984 9.1665L11.6665 7.49984M9.99984 9.1665V14.9998"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const DollarConversion = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.3075 5.3457H9.48188C9.31676 5.3457 9.17228 5.49307 9.17228 5.66149V6.39834C8.09901 6.60886 7.33534 7.61939 7.43853 8.75623C7.54173 9.85097 8.51181 10.7141 9.66764 10.7141H10.2043C10.39 10.7141 10.5964 10.7983 10.7203 10.9457C10.8441 11.0931 10.906 11.2825 10.906 11.4931C10.8647 11.851 10.5345 12.1247 10.163 12.1247H9.41996C9.21356 12.1247 9.0278 11.9773 8.98652 11.7668C8.96588 11.6404 8.84204 11.5352 8.69756 11.5352H7.85133C7.76877 11.5352 7.68621 11.5773 7.62429 11.6404C7.56237 11.7036 7.54173 11.7878 7.54173 11.872C7.62429 12.7562 8.30541 13.472 9.17228 13.5773V14.2931C9.17228 14.4615 9.31676 14.6089 9.48188 14.6089H10.3075C10.4726 14.6089 10.6171 14.4615 10.6171 14.2931V13.5773C11.5459 13.3668 12.2476 12.5878 12.3508 11.6615C12.4127 11.0299 12.227 10.4404 11.8142 9.97728C11.4014 9.51412 10.8235 9.26149 10.2249 9.26149H9.58508C9.39932 9.26149 9.19292 9.17728 9.06908 9.02991C8.94524 8.88255 8.88332 8.69307 8.88332 8.48255C8.9246 8.12465 9.25484 7.85097 9.62636 7.85097H10.3694C10.5758 7.85097 10.7615 7.99833 10.8028 8.20886C10.8235 8.35623 10.9473 8.44044 11.0918 8.44044H11.938C12.0206 8.44044 12.1031 8.39833 12.1651 8.33518C12.227 8.27202 12.2476 8.18781 12.2476 8.1036C12.1651 7.21939 11.4839 6.5036 10.6171 6.39834V5.68255C10.6171 5.49307 10.4726 5.3457 10.3075 5.3457Z"
      fill="currentColor"
    />
    <path
      d="M10.0804 1.42917V0.460746C10.0804 0.292325 9.99786 0.144957 9.85338 0.0607461C9.7089 -0.0234645 9.54378 -0.0234644 9.3993 0.0817987L6.79868 1.70285C6.67484 1.78706 6.59229 1.93443 6.59229 2.0818C6.59229 2.22917 6.67484 2.37654 6.79868 2.46075L9.37866 4.10285C9.46122 4.14496 9.52314 4.16601 9.6057 4.16601C9.68826 4.16601 9.75018 4.14496 9.83274 4.10285C9.97722 4.01864 10.0598 3.87127 10.0598 3.70285V2.86075C13.8162 3.00811 16.8503 6.14496 16.8503 9.99759C16.8503 11.8923 16.1279 13.6818 14.8069 15.0081C14.518 15.3029 14.518 15.766 14.8069 16.0607C14.9514 16.2081 15.1372 16.2713 15.3229 16.2713C15.5087 16.2713 15.6945 16.2081 15.8389 16.0607C17.4282 14.4397 18.3157 12.2923 18.3157 9.99759C18.3157 5.3239 14.6212 1.53443 10.0804 1.42917Z"
      fill="currentColor"
    />
    <path
      d="M10.4107 15.8713C10.2662 15.7871 10.1011 15.7871 9.9566 15.8502C9.81213 15.9344 9.72957 16.0818 9.72957 16.2502V17.0923C5.95248 16.9871 2.93906 13.8502 2.93906 9.99759C2.93906 8.10285 3.66145 6.33443 4.9824 4.98706C5.27136 4.69233 5.27136 4.22917 4.9824 3.93443C4.69345 3.63969 4.23937 3.63969 3.95041 3.93443C2.36115 5.55548 1.47363 7.70285 1.47363 9.99759C1.47363 14.6713 5.14752 18.4818 9.70893 18.566V19.5344C9.70893 19.7029 9.79148 19.8502 9.93596 19.9344C9.99788 19.9765 10.0804 19.9976 10.163 19.9976C10.2456 19.9976 10.3281 19.9765 10.39 19.9344L12.9907 18.2923C13.1145 18.2081 13.1971 18.0607 13.1971 17.9134C13.1971 17.766 13.1145 17.6186 12.9907 17.5344L10.4107 15.8713Z"
      fill="currentColor"
    />
  </svg>
);

const CoinDollarOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <circle cx="12.5" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
    <path
      d="M14.5 10C14.5 8.89543 13.6046 8 12.5 8C11.3954 8 10.5 8.89543 10.5 10C10.5 11.1046 11.3954 12 12.5 12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.5 12C13.6046 12 14.5 12.8954 14.5 14C14.5 15.1046 13.6046 16 12.5 16C11.3954 16 10.5 15.1046 10.5 14"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.5 6.5V8"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 16V17.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const DownArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M15.0536 4L5.94636 4C4.41071 4 3.44798 5.65896 4.20987 6.99228L8.76351 14.9611C9.5313 16.3048 11.4687 16.3048 12.2365 14.9611L16.7901 6.99228C17.552 5.65897 16.5893 4 15.0536 4Z"
      fill="#CD4D4B"
      stroke="#CD4D4B"
      stroke-linejoin="round"
    />
  </svg>
);

const UpArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.44636 16L14.5536 16C16.0893 16 17.052 14.341 16.2901 13.0077L11.7365 5.03885C10.9687 3.69522 9.0313 3.69522 8.26352 5.03885L3.70987 13.0077C2.94798 14.341 3.91071 16 5.44636 16Z"
      fill="#009D2C"
      stroke="#009D2C"
      stroke-linejoin="round"
    />
  </svg>
);

const GraphInLens = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.77979 3.73438H5.9126V9.95833H7.77979V3.73438Z"
      fill="currentColor"
    />
    <path
      d="M10.5806 5.60156H8.71338V9.95833H10.5806V5.60156Z"
      fill="currentColor"
    />
    <path
      d="M4.979 7.46875H3.11182V9.95833H4.979V7.46875Z"
      fill="currentColor"
    />
    <path
      d="M13.6927 6.84635C13.6927 3.06519 10.6275 0 6.84635 0C3.06519 0 0 3.06519 0 6.84635C0 10.6275 3.06519 13.6927 6.84635 13.6927C8.51285 13.6927 10.0392 13.0963 11.2264 12.1065L15.1199 16L16 15.1199L12.1066 11.2264C13.0963 10.0392 13.6927 8.51285 13.6927 6.84635ZM6.84635 12.4479C3.75764 12.4479 1.24479 9.93507 1.24479 6.84635C1.24479 3.75764 3.75764 1.24479 6.84635 1.24479C9.93507 1.24479 12.448 3.75764 12.448 6.84635C12.448 9.93507 9.93507 12.4479 6.84635 12.4479Z"
      fill="currentColor"
    />
  </svg>
);

const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17.2866 13.1005L16.647 12.7088L16.647 12.7088L17.2866 13.1005ZM16.4911 14.3995L17.1307 14.7912V14.7912L16.4911 14.3995ZM2.71341 6.89951L2.0738 6.50785H2.0738L2.71341 6.89951ZM3.50887 5.60048L4.14848 5.99214L4.14848 5.99214L3.50887 5.60048ZM5.6821 5.05144L6.04068 4.39271L6.04068 4.39271L5.6821 5.05144ZM3.29572 8.94855L2.93714 9.60728H2.93714L3.29572 8.94855ZM14.3179 14.9486L13.9593 15.6073L13.9593 15.6073L14.3179 14.9486ZM16.7043 11.0514L16.3457 11.7102H16.3457L16.7043 11.0514ZM3.50887 14.3995L2.86925 14.7912H2.86925L3.50887 14.3995ZM2.71341 13.1005L3.35302 12.7088H3.35302L2.71341 13.1005ZM16.4911 5.60049L17.1307 5.20883V5.20882L16.4911 5.60049ZM17.2866 6.89952L16.647 7.29119L16.647 7.29119L17.2866 6.89952ZM16.7043 8.94856L17.0629 9.60729L16.7043 8.94856ZM14.3179 5.05145L14.6765 5.71017V5.71017L14.3179 5.05145ZM3.29572 11.0514L3.6543 11.7102H3.6543L3.29572 11.0514ZM5.6821 14.9486L5.32352 14.2898L5.32351 14.2898L5.6821 14.9486ZM14.2333 5.09748L13.8748 4.43876V4.43876L14.2333 5.09748ZM5.76667 5.09747L5.40808 5.7562L5.40808 5.7562L5.76667 5.09747ZM14.2333 14.9025L14.5919 14.2438L14.5919 14.2438L14.2333 14.9025ZM5.76667 14.9025L6.12524 15.5613L6.12525 15.5613L5.76667 14.9025ZM9.20454 3.25H10.7955V1.75H9.20454V3.25ZM10.7955 16.75H9.20454V18.25H10.7955V16.75ZM9.20454 16.75C8.69793 16.75 8.36363 16.3732 8.36363 16H6.86363C6.86363 17.2836 7.95388 18.25 9.20454 18.25V16.75ZM11.6364 16C11.6364 16.3732 11.3021 16.75 10.7955 16.75V18.25C12.0461 18.25 13.1364 17.2836 13.1364 16H11.6364ZM10.7955 3.25C11.3021 3.25 11.6364 3.62675 11.6364 4H13.1364C13.1364 2.71639 12.0461 1.75 10.7955 1.75V3.25ZM9.20454 1.75C7.95388 1.75 6.86363 2.71639 6.86363 4H8.36363C8.36363 3.62675 8.69793 3.25 9.20454 3.25V1.75ZM16.647 12.7088L15.8515 14.0079L17.1307 14.7912L17.9262 13.4921L16.647 12.7088ZM3.35302 7.29117L4.14848 5.99214L2.86926 5.20881L2.0738 6.50785L3.35302 7.29117ZM4.14848 5.99214C4.36925 5.63159 4.89631 5.47761 5.32351 5.71016L6.04068 4.39271C4.94603 3.79684 3.52712 4.13448 2.86926 5.20881L4.14848 5.99214ZM3.65431 8.28983C3.2505 8.07001 3.14948 7.62357 3.35302 7.29117L2.0738 6.50785C1.3987 7.61034 1.8191 8.99866 2.93714 9.60728L3.65431 8.28983ZM15.8515 14.0079C15.6307 14.3684 15.1037 14.5224 14.6765 14.2898L13.9593 15.6073C15.054 16.2032 16.4729 15.8655 17.1307 14.7912L15.8515 14.0079ZM17.9262 13.4921C18.6013 12.3897 18.1809 11.0013 17.0629 10.3927L16.3457 11.7102C16.7495 11.93 16.8505 12.3764 16.647 12.7088L17.9262 13.4921ZM4.14848 14.0079L3.35302 12.7088L2.0738 13.4921L2.86925 14.7912L4.14848 14.0079ZM15.8515 5.99215L16.647 7.29119L17.9262 6.50786L17.1307 5.20883L15.8515 5.99215ZM16.647 7.29119C16.8505 7.62358 16.7495 8.07002 16.3457 8.28984L17.0629 9.60729C18.1809 8.99867 18.6013 7.61035 17.9262 6.50786L16.647 7.29119ZM14.6765 5.71017C15.1037 5.47762 15.6307 5.63161 15.8515 5.99215L17.1307 5.20882C16.4729 4.13449 15.054 3.79685 13.9593 4.39272L14.6765 5.71017ZM3.35302 12.7088C3.14948 12.3764 3.2505 11.93 3.6543 11.7102L2.93714 10.3927C1.8191 11.0013 1.3987 12.3897 2.0738 13.4921L3.35302 12.7088ZM2.86925 14.7912C3.52712 15.8655 4.94603 16.2032 6.04068 15.6073L5.32351 14.2898C4.89631 14.5224 4.36925 14.3684 4.14848 14.0079L2.86925 14.7912ZM14.5919 5.75621L14.6765 5.71017L13.9593 4.39272L13.8748 4.43876L14.5919 5.75621ZM5.32351 5.71016L5.40808 5.7562L6.12525 4.43875L6.04068 4.39271L5.32351 5.71016ZM14.6765 14.2898L14.5919 14.2438L13.8748 15.5612L13.9593 15.6073L14.6765 14.2898ZM5.40809 14.2438L5.32352 14.2898L6.04067 15.6073L6.12524 15.5613L5.40809 14.2438ZM2.93714 9.60728C3.24828 9.77665 3.24829 10.2233 2.93714 10.3927L3.6543 11.7102C5.00923 10.9726 5.00923 9.02739 3.65431 8.28983L2.93714 9.60728ZM6.12525 15.5613C6.45812 15.38 6.86363 15.621 6.86363 16H8.36363C8.36363 14.483 6.74049 13.5185 5.40808 14.2438L6.12525 15.5613ZM13.1364 16C13.1364 15.621 13.5419 15.38 13.8748 15.5612L14.5919 14.2438C13.2595 13.5185 11.6364 14.483 11.6364 16H13.1364ZM17.0629 10.3927C16.7517 10.2233 16.7517 9.77666 17.0629 9.60729L16.3457 8.28984C14.9908 9.0274 14.9908 10.9726 16.3457 11.7102L17.0629 10.3927ZM5.40808 5.7562C6.74049 6.4815 8.36363 5.51702 8.36363 4H6.86363C6.86363 4.379 6.45812 4.61995 6.12525 4.43875L5.40808 5.7562ZM13.8748 4.43876C13.5419 4.61996 13.1364 4.379 13.1364 4H11.6364C11.6364 5.51703 13.2595 6.48151 14.5919 5.75621L13.8748 4.43876ZM11.75 10C11.75 10.9665 10.9665 11.75 10 11.75V13.25C11.7949 13.25 13.25 11.7949 13.25 10H11.75ZM10 11.75C9.03351 11.75 8.25001 10.9665 8.25001 10H6.75001C6.75001 11.7949 8.20508 13.25 10 13.25V11.75ZM8.25001 10C8.25001 9.0335 9.03351 8.25 10 8.25V6.75C8.20508 6.75 6.75001 8.20507 6.75001 10H8.25001ZM10 8.25C10.9665 8.25 11.75 9.0335 11.75 10H13.25C13.25 8.20507 11.7949 6.75 10 6.75V8.25Z"
      fill="currentColor"
    />
  </svg>
);

const ChartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.01882 6.9475C6.88235 5.1125 7.47765 4 8.47059 4C9.46353 4 10.0588 5.1125 10.9224 6.9475C11.8165 8.8475 12.8306 11 15.0588 11C15.3084 11 15.5478 10.8946 15.7243 10.7071C15.9008 10.5196 16 10.2652 16 10C16 9.73478 15.9008 9.48043 15.7243 9.29289C15.5478 9.10536 15.3084 9 15.0588 9C14.0659 9 13.4706 7.8875 12.6071 6.0525C11.7129 4.1525 10.6988 2 8.47059 2C6.24235 2 5.22823 4.1525 4.33412 6.0525C3.47059 7.8875 2.87529 9 1.88235 9V1C1.88235 0.734784 1.78319 0.48043 1.60669 0.292893C1.43018 0.105357 1.19079 0 0.941176 0C0.691561 0 0.452169 0.105357 0.275664 0.292893C0.0991596 0.48043 0 0.734784 0 1V13.5C0 13.8283 0.0608604 14.1534 0.179107 14.4567C0.297353 14.76 0.47067 15.0356 0.689161 15.2678C0.907651 15.4999 1.16704 15.6841 1.45251 15.8097C1.73798 15.9353 2.04395 16 2.35294 16H15.0588C15.3084 16 15.5478 15.8946 15.7243 15.7071C15.9008 15.5196 16 15.2652 16 15C16 14.7348 15.9008 14.4804 15.7243 14.2929C15.5478 14.1054 15.3084 14 15.0588 14H2.35294C2.22813 14 2.10844 13.9473 2.02019 13.8536C1.93193 13.7598 1.88235 13.6326 1.88235 13.5V11C4.11059 11 5.12471 8.8475 6.01882 6.9475Z"
      fill="currentColor"
    />
  </svg>
);

const BarGraphIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15.141 6.16162H12.2889C12.1171 6.16162 11.9453 6.29779 11.9453 6.50205V15.6595C11.9453 15.8297 12.0828 15.9999 12.2889 15.9999H15.141C15.3128 15.9999 15.4846 15.8637 15.4846 15.6595V6.50205C15.4846 6.33183 15.3471 6.16162 15.141 6.16162Z"
      fill="currentColor"
    />
    <path
      d="M10.1585 8.37427H7.30651C7.1347 8.37427 6.96289 8.51044 6.96289 8.71469V15.6594C6.96289 15.8296 7.10034 15.9998 7.30651 15.9998H10.1585C10.3303 15.9998 10.5022 15.8636 10.5022 15.6594V8.71469C10.5022 8.51044 10.3303 8.37427 10.1585 8.37427Z"
      fill="currentColor"
    />
    <path
      d="M5.14175 10.2808H2.32409C2.15228 10.2808 1.98047 10.4169 1.98047 10.6212V15.6595C1.98047 15.8297 2.11792 15.9999 2.32409 15.9999H5.17612C5.34792 15.9999 5.51973 15.8637 5.51973 15.6595V10.6212C5.48537 10.4169 5.34792 10.2808 5.14175 10.2808Z"
      fill="currentColor"
    />
    <path
      d="M15.4846 0H13.0105C12.7356 0 12.5295 0.204255 12.5295 0.476596C12.5295 0.748936 12.7356 0.953192 13.0105 0.953192H14.1101C14.1788 0.953192 14.2475 1.05532 14.1788 1.1234L10.0554 4.83404C9.95233 4.90213 9.81488 4.90213 9.74615 4.83404L6.85977 2.38298C6.68796 2.21277 6.41306 2.24681 6.24125 2.38298L0.159217 8.10213C-0.0469542 8.27234 -0.0469542 8.57872 0.124855 8.74894C0.22794 8.85106 0.331025 8.88511 0.468473 8.88511C0.571558 8.88511 0.709005 8.85106 0.777729 8.74894L6.41306 3.47234C6.51615 3.40426 6.65359 3.37021 6.72232 3.47234L9.60871 5.9234C9.78052 6.09362 10.0554 6.05957 10.2272 5.9234L14.8661 1.73617C14.9348 1.66809 15.0379 1.73617 15.0379 1.80426V2.89362C15.0379 3.16596 15.244 3.37021 15.5189 3.37021C15.7938 3.37021 16 3.16596 16 2.89362V0.476596C15.9656 0.204255 15.7595 0 15.4846 0Z"
      fill="currentColor"
    />
  </svg>
);

const BellIcon = () => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.333496 14.8337V13.167H2.00016V7.33366C2.00016 6.18088 2.34738 5.15658 3.04183 4.26074C3.73627 3.36491 4.63905 2.7781 5.75016 2.50033V1.91699C5.75016 1.56977 5.87169 1.27463 6.11475 1.03158C6.3578 0.78852 6.65294 0.666992 7.00016 0.666992C7.34738 0.666992 7.64252 0.78852 7.88558 1.03158C8.12863 1.27463 8.25016 1.56977 8.25016 1.91699V2.50033C9.36127 2.7781 10.2641 3.36491 10.9585 4.26074C11.6529 5.15658 12.0002 6.18088 12.0002 7.33366V13.167H13.6668V14.8337H0.333496ZM7.00016 17.3337C6.54183 17.3337 6.14947 17.1705 5.82308 16.8441C5.49669 16.5177 5.3335 16.1253 5.3335 15.667H8.66683C8.66683 16.1253 8.50364 16.5177 8.17725 16.8441C7.85086 17.1705 7.4585 17.3337 7.00016 17.3337ZM3.66683 13.167H10.3335V7.33366C10.3335 6.41699 10.0071 5.63227 9.35433 4.97949C8.70155 4.32671 7.91683 4.00033 7.00016 4.00033C6.0835 4.00033 5.29877 4.32671 4.646 4.97949C3.99322 5.63227 3.66683 6.41699 3.66683 7.33366V13.167Z"
      fill="currentColor"
    />
  </svg>
);
const FilterIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M15.6824 1.66602H4.31764C2.86834 1.66602 2.00388 3.2623 2.80781 4.45405L7.57589 10.6889C7.97333 11.278 8.18541 11.9703 8.18541 12.6784V17.4342C8.18541 18.2331 9.16269 18.6331 9.73426 18.0683L11.5489 16.275C11.719 16.1068 11.8146 15.8788 11.8146 15.6409V12.6784C11.8146 11.9703 12.0267 11.278 12.4241 10.6889L17.1922 4.45405C17.9961 3.26231 17.1317 1.66602 15.6824 1.66602Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
export {
  WidgesOutline,
  ShippingDeliveryOutline,
  ChartArrowOutline,
  ChatNotificationOutline,
  IdCardOutline,
  IdeaOutline,
  DollarConversion,
  GraphInLens,
  DownArrow,
  ShippingDeliveryOutlineReturn,
  CoinDollarOutline,
  UpArrow,
  SettingsIcon,
  ChartIcon,
  BarGraphIcon,
  BellIcon,
  DeviceOutlineComputer,
  TruckOutline,
  MobileOutline,
  FilterIcon
};
